'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.sendAnalyticsEvents = sendAnalyticsEvents;
exports.isBiblioLink = isBiblioLink;

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _endsWith = require('lodash/endsWith');

var _endsWith2 = _interopRequireDefault(_endsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var CORE_DOMAIN_POSTFIXES = ['.bibliocommons.com', '.bcommons.net'];

/**
 * @definition updates missing paramaters from event payload with values of undefined
 * @param {Object} payload
 * @example
 * old payload: {action: 'add', label: 'new'}
 * new payload: {action: 'remove' }
 * returns: {action: 'remove', label: undefined}
 */
function transformPayload(payload) {
  var newPayload = _extends({}, payload);
  var latestBCEvent = [].concat(_toConsumableArray(window.dataLayer)).reverse().find(function (event) {
    return event.payload;
  });

  // compares the latestBCEvent payload keys to the upcoming event's payload keys
  if (latestBCEvent) {
    Object.keys(latestBCEvent.payload).forEach(function (key) {
      // if a key is missing on the upcoming payload, define it as undefined; this prevents the new payload from using the old payload values
      if (!Object.prototype.hasOwnProperty.call(newPayload, key)) {
        newPayload[key] = undefined;
      }
    });
  }
  return newPayload;
}

/**
 * @definition pushes current analytic event to data layer for tracking
 * @param {Array} analytics holds events array which holds objects with following shape: { event, payload }
 */
function sendAnalyticsEvents(analytics) {
  if (analytics && analytics.events) {
    analytics.events.forEach(function (event) {
      if (event.event) {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: event.event,
            payload: transformPayload(event.payload)
          });
        }
      }
    });
  }
}

function isCmsHostname(hostname) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    var data = window.dataLayer[0] || {};
    var cmsUrl = data['bc.cmsUrl'];

    if (cmsUrl) {
      var cmsHostname = new _urlParse2.default(cmsUrl).hostname;
      return cmsHostname === hostname;
    }
  }

  return false;
}

function isCoreHostname(hostname) {
  return CORE_DOMAIN_POSTFIXES.some(function (biblioDomainPostfix) {
    return (0, _endsWith2.default)(hostname, biblioDomainPostfix);
  });
}

/**
 * Checks if a URL should be considered internal to Bibliocommons,
 * for the purposes of internal analytics tracking.
 *
 * A URL is "external" if the domain is not CORE or Web.
 *
 * @param {string} url
 * @returns {boolean}
 */
function isBiblioLink(url) {
  var hostname = new _urlParse2.default(url).hostname;
  return isCoreHostname(hostname) || isCmsHostname(hostname);
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-analytics/lib/index.js
// module id = 117
// module chunks = 0 2 4 5 6 8 9 10 11